import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { BreadcrumbComponent } from "@lib/base/components/navigation/breadcrumb/breadcrumb.component";
import { NavigationMenuComponent } from "@lib/base/components/navigation/navigation-menu/navigation-menu.component";
import { SidebarComponent } from "@lib/base/components/navigation/sidebar/sidebar.component";
import { SidenavComponent } from "@lib/base/components/navigation/sidenav/sidenav.component";
import { APP_NAVIGATION } from "@pages/app.navigation";
import { WORKSPACE_NAVIGATION } from "./workspace-home.navigation";
import { AlertsMenuComponent } from "@custom/base/components/alerts/alerts/alerts-menu.component";

@Component({
    selector: "app-workspace-home",
    imports: [
        SidebarComponent,
        RouterOutlet,
        SidenavComponent,
        BreadcrumbComponent,
        NavigationMenuComponent,
        AlertsMenuComponent,
    ],
    templateUrl: "./workspace-home.component.html",
    styleUrl: "./workspace-home.component.scss",
})
export class WorkspaceHomeComponent {
    protected readonly navigationData = WORKSPACE_NAVIGATION;
    protected readonly APP_NAVIGATION = APP_NAVIGATION;
}
